import axios from 'axios'
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'

const AssignAgentModal = ({ show, onHide, selectedRows, selectedUser, type, onSuccess }) => {
    const token = localStorage.getItem('kt-auth-react-v.api_token')
    const [selectedAgent, setSelectedAgent] = useState('')
    const [agentList, setAgentList] = useState([])

    useEffect(() => {
        if (show) {
            const user = type === 'agent' ? selectedUser.agent : selectedUser.manager
            setSelectedAgent(user || '')
        }
    }, [show, type, selectedUser])

    useEffect(() => {
        if (show) {
            if (type === 'agent') getAgents()
            else if (type === 'manager') getManagers()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, type])

    const getAgents = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/leads/agents`, {
                headers: { Authorization: ` ${token}` },
            })
            setAgentList(data?.result || [])
        } catch (error) {
            console.log(error)
            toast.error('Failed to fetch agents.')
        }
    }

    const getManagers = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/leads/managers`, {
                headers: { Authorization: ` ${token}` },
            })
            setAgentList(data?.result || [])
        } catch (error) {
            console.log(error)
            toast.error('Failed to fetch managers.')
        }
    }

    const handleBulkAssignAgent = async () => {
        if (!selectedAgent) return

        try {
            const res = await axios.patch(
                `${process.env.REACT_APP_API_URL}/leads/bulk-assign`,
                {
                    ids: selectedRows,
                    userId: selectedAgent,
                    type,
                },
                {
                    headers: { Authorization: ` ${token}` },
                },
            )

            toast.success(res.data.message)
            setSelectedAgent('')
            onSuccess()
        } catch (error) {
            toast.error(error.response?.data?.message || `Failed to assign ${type}.`)
        }
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{`Assign ${type === 'agent' ? 'Agent' : 'Manager'} to Selected Leads`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <label className="form-label">{`Select ${type === 'agent' ? 'an Agent' : 'a Manager'}`}</label>
                    <select
                        className="form-select"
                        value={selectedAgent}
                        onChange={(e) => setSelectedAgent(e.target.value)}
                    >
                        <option value="">{`Select ${type === 'agent' ? 'an Agent' : 'a Manager'}`}</option>
                        {agentList.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                                {agent.full_name}
                            </option>
                        ))}
                    </select>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-secondary" onClick={onHide}>
                    Cancel
                </button>
                <button className="btn btn-sm btn-dark" onClick={handleBulkAssignAgent} disabled={!selectedAgent}>
                    {`Assign ${type === 'agent' ? 'Agent' : 'Manager'}`}
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default AssignAgentModal
